<template>
  <hooper v-if="dir === 'rtl'" :wheelControl="false" :autoPlay="true" :playSpeed="5000" rtl="1">
    <slide v-for="(image,index) in images" :key="index">
      <img class="hooper-img" :src="JSON.parse(image)[lang]" />
    </slide>
  </hooper>
  <hooper v-else :wheelControl="false" :autoPlay="true" :playSpeed="5000" rtl="0">
    <slide v-for="(image,index) in images" :key="index">
      <img class="hooper-img" :src="JSON.parse(image)[lang]" />
    </slide>
  </hooper>
</template>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

export default {
  props: {
    images: {
      type: [Array, Object],
      required: true
    },
    lang: {
      type: String,
      required: true
    },
    dir: {
      type: String,
      required: true
    }
  },
  components: {
    Hooper,
    Slide
  }
};
</script>
<style>
.hooper {
  height: calc(100vh - 90px);
}
.hooper .hooper-slide .hooper-img {
  width: 100%;
  height: 100%;
}
</style>
